<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                <router-link :to="{ name: 'Users', query: { page: this.$route.query.page } }">Пользователи</router-link> &raquo;
                <span>{{ item && item.userName ? item.userName : 'Новый пользователь' }}</span>
            </template>
            <h2>Карточка пользователя</h2>
        </page-header>
      <div>
        <ul class="nav nav-tabs nav-justified mt-3">
          <li class="nav-item">
            <a
                class="nav-link"
                @click.prevent="setActive('tab1')"
                :class="{ active: isActive('tab1') }"
                href="#tab1"
            >Общая информация<i
                class="fas fa-info-circle text-danger ml-2"
                v-if="tab1Invalid"
              ></i
            ></a>
          </li>

          <li class="nav-item">
            <a
                class="nav-link"
                @click.prevent="setActive('tab3')"
                :class="{ active: isActive('tab3') }"
                href="#tab3"
            >Организации<i
                class="fas fa-info-circle text-danger ml-2"
                v-if="tab2Invalid"
              ></i
            ></a>
          </li>
          <li class="nav-item">
            <a
                class="nav-link"
                @click.prevent="setActive('tab2')"
                :class="{ active: isActive('tab2') }"
                href="#tab1"
            >Роли<i
                class="fas fa-info-circle text-danger ml-2"
                v-if="tab3Invalid"
              ></i
            ></a>
          </li>
        </ul>
      </div>
        <div class="card" v-if="item">

            <div>
                <div class="tab-content p-3" id="myTabContent" v-disable-all="isReadonly">
                    <div
                        class="tab-pane fade"
                        :class="{ 'active show': isActive('tab1') }"
                        id="tab1"
                    >
                        <div class="row mt-10">
                            <div class="col-md-3">
                                <div class="form-group required">
                                  <component-input
                                      v-model="item.surname"
                                      label="Фамилия:" required
                                      scopeName="tab1"
                                      placeholder="Введите фамилию"/>
                                </div>
                            </div>
                          <div class="col-md-3">
                            <div class="form-group required">
                              <component-input
                                  v-model="item.name"
                                  label="Имя:" required
                                  scopeName="tab1"
                                  placeholder="Введите имя"/>

                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <component-input
                                  v-model="item.patronymic"
                                  label="Отчество:"
                                  scopeName="tab1"
                                  placeholder="Введите отчество"/>
                            </div>
                          </div>
                        </div>


                        <div class="row mt-10">
                            <div class="col-md-3">
                                <div class="form-group required">
                                  <component-input
                                      v-model="item.email"
                                      label="E-mail:"
                                      required
                                      scopeName="tab1"
                                      placeholder="Введите E-mail"/>

                                </div>
                            </div>
                          <div class="col-md-3">
                            <div class="form-group required">
                              <component-input
                                  v-model="item.phoneNumber"
                                  label="Телефон:"
                                  required
                                  type="phone"
                                  scopeName="tab1"
                                  placeholder="Введите телефон"/>

                            </div>
                          </div>
                        </div>

                        <div class="row mt-10">
                            <div class="col-md-3">
                                <div class="form-group required">
                                  <component-input
                                      v-model="item.userName"
                                      label="Логин:"
                                      required
                                      scopeName="tab1"
                                      placeholder="Введите имя пользователя"/>

                                </div>
                            </div>
                          <!-- <div v-if="!isReadonly" class="col-md-3">
                            <div :class="'form-group' + (isNew() ? ' required' : '')">
                              <label class="control-label">Пароль:</label>
                              <input type="password" class="form-control" v-model="item.password" autocomplete="new-password" :placeholder="isNew() ? '' : 'Для смены пароля введите новый пароль в это поле'"/>
                              <div class="invalid-msg" v-if="v$.item.password.$error">
                                <template v-if="v$.item.password.minLength.$invalid">Минимальная длина пароля {{v$.item.password.minLength.$params.min}} символов.</template>
                                <template v-if="v$.item.password.strength.$invalid">{{passwordMessage}}</template>
                                <template v-else>Введите данные.</template>
                              </div>
                            </div>
                          </div>
                          <div  v-if="!isReadonly" class="col-md-3">
                            <div :class="'form-group' + (isNew() ? ' required' : '')">
                              <label class="control-label">Подтверждение пароля:</label>
                              <input type="password" class="form-control" v-model="item.confirmPassword" autocomplete="new-password" :placeholder="isNew() ? '' : 'Введите новый пароль еще раз'"/>
                              <div class="invalid-msg" v-if="v$.item.confirmPassword.$error">
                                <template v-if="v$.item.confirmPassword.sameAsPassword.$invalid">Пароль и подтверждение не совпадают.</template>
                                <template v-else>Введите данные.</template>
                              </div>
                            </div>
                          </div> -->
                        </div>


                        <div class="form-check my-3">
                            <input type="checkbox" class="form-check-input" v-model="item.isDisabled" id="chkIsDisabled">
                            <label for="chkIsDisabled" class="form-check-label">Учетная запись заблокирована</label>
                        </div>
                    </div>
                    <div
                            class="tab-pane fade"
                            :class="{ 'active show': isActive('tab2') }"
                            id="tab2"
                    >
                        <ul v-if="item.employees.length">
                            <li v-for="role in roles" :key="role.id" class="mx-2 p-1">
                                <input type="checkbox" class="form-check-input" v-model="item.roleIds" :true-value="[]" :value="role.id" :id="'chkRole_' + role.id">
                                <label :for="'chkRole_' + role.id" class="form-check-label">{{role.name}}</label>
                            </li>
                        </ul>
                        <p v-else>Выбор ролей недоступен, пока не выбрана ни одна организация</p>
                        <div class="invalid-msg" v-if="v$.item.roleIds.$error">Поле обязательно для заполнения</div>
                    </div>
                    <div
                            class="tab-pane fade"
                            :class="{ 'active show': isActive('tab3') }"
                            id="tab3"
                    >
                        <template v-if="item.employees.length">
                          <div class="table-inner">
                        <table class="table-custom">
                            <thead>
                            <tr>
                              <th v-if="!isReadonly"></th>
                                <th width="30%">Организация</th>
                                <th>Должность</th>
                                <th>Контактный телефон</th>
                                <th>Добавочный номер</th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(org, index) in item.employees" :key="org.id">
                              <td v-if="!isReadonly" class="icon align-middle text-center">
                                <i class="fas fa-trash-alt" v-on:click="deleteOrganization(index)"></i>
                              </td>
                                <td class="align-top">
                                    <component-input
                                      placeholder="Не выбрано"
                                      v-model="org.organizationId"
                                      type="select2"
                                      :select2Options="organizations" 
                                      :select2Settings="select2Settings"
                                      required
                                      v-on:select2OnSelect="organizationChanged()" />
                                    <!-- <div class="select2">
                                      <Select2 :options="organizations"  placeholder="Не выбрано"
                                               class="select2" v-model="org.organizationId"
                                               style="max-width: 100%"
                                               :settings="select2Settings" v-on:select="organizationChanged()">
                                      </Select2>
                                    </div> -->
                                </td>
                                <td class="align-top">
                                  <component-input
                                      v-model="org.position"
                                      required
                                      scopeName="tab2"
                                      placeholder="Должность" />
                                    <!-- <input type="text" class="form-control" v-model="org.position"> -->
                                </td>
                                <td class="align-top">
                                    <input type="text" class="form-control phone" v-model="org.phone">
                                </td>
                                <td class="align-top">
                                    <input type="text" class="form-control" v-model="org.additionalNumber">
                                </td>

                            </tr>
                            </tbody>
                        </table>
                          </div>
                        </template>
                        <template v-else>
                            <EmptyListMessage/>
                        </template>

                        <div class="invalid-msg" v-if="v$.item.employees.required.$invalid">Необходимо добавить хотя бы одну организацию.</div>
                        <div class="invalid-msg" v-else-if="v$.item.employees.$error">Не все обязательные поля заполнены.</div>

                        <button-component class="btn btn-primary btn-sm mt-4" v-on:click="addOrganization()">Добавить организацию</button-component>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="float-right d-flex align-items-center">
                    <button-component type="button" class="btn btn-primary mr-2 btn-sm" v-if="!isReadonly" v-on:click="save">Сохранить</button-component>
                    <button-component type="button" kind="secondary" class="btn btn-secondary btn-sm" v-on:click="close">Закрыть</button-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import API from "../../admin/api/users";
  import RoleAPI from "../../admin/api/roles";
  import OrgAPI from "../../organization/api/organizations";
  import Constants from "../../../common/constants";
  import {maxLength, required, email} from "@vuelidate/validators";
  import {useVuelidate} from "@vuelidate/core";
  import EmptyListMessage from "../../../common/components/EmptyListMessage";
  import Inputmask from 'inputmask';
  import disableAll from "../../../common/directives/disable-all";
  import security from "../../../common/mixins/security";
  import ComponentInput from "../../../common/components/ComponentInput";
  import ButtonComponent from "../../../common/ui/ButtonComponent";

  function orgCompare (a, b) {
            if (a.text > b.text) {
              return 1;
            }
            if (a.text < b.text) {
              return -1;
            }
            return 0;
          }

  export default {
    name: "UserCard",
    components: {
      ButtonComponent,
      ComponentInput,
      EmptyListMessage,
      PageHeader
    },
    directives: {
      'disable-all': disableAll
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        isReadonly: this.$route.params.action === 'view',
        isEdit: this.$route.params.action === "edit",
        item: {
          roleIds: [],
          employees: []
        },
        activeItem: "tab1",
        roles: [],
        organizations: [],
        select2Settings: Constants.select2Settings,
        //passRegExp: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])"),
        //passwordMessage: 'Пароль должен содержать букву в верхнем регистре и цифру.'

        tab1Invalid: false,
        tab2Invalid: false,
        tab3Invalid: false,
      };
    },
    created() {
      this.checkPermissions([Constants.UserEdit, Constants.UserView]);
      this.loadDependencies();
      this.loadCard()
    },
    watch: {
      'item.employees': {
        handler() {
          const inputs = document.querySelectorAll('.phone');
          inputs.forEach((input) => {
            if (!input.inputmask) {
              var im = new Inputmask(Constants.phoneInputMask);
              im.mask(input);
          }
          });
        },
        deep: true
      },
      'item.surname': function() {
        this.generateLogin();
      },
      'item.name': function() {
        this.generateLogin();
      },
      'item.patronymic': function() {
        this.generateLogin();
      }
    },
    methods: {
      generateLogin() {
        if(this.id == 0) {
          this.item.userName = this.transliteration(this.item.surname);
          if(this.item.name && this.item.name.length > 0)
            this.item.userName += this.transliteration(this.item.name.substring(0,1));
          if(this.item.patronymic && this.item.patronymic.length > 0)
            this.item.userName += this.transliteration(this.item.patronymic.substring(0,1));
        }
      },
      transliteration(word) {
        if(!word)
          return "";

        var answer = "";
        var a = {};
        a["Ё"]="YO";a["Й"]="I";a["Ц"]="TS";a["У"]="U";a["К"]="K";a["Е"]="E";a["Н"]="N";a["Г"]="G";a["Ш"]="SH";a["Щ"]="SCH";a["З"]="Z";a["Х"]="H";a["Ъ"]="";
        a["ё"]="yo";a["й"]="i";a["ц"]="ts";a["у"]="u";a["к"]="k";a["е"]="e";a["н"]="n";a["г"]="g";a["ш"]="sh";a["щ"]="sch";a["з"]="z";a["х"]="h";a["ъ"]="";
        a["Ф"]="F";a["Ы"]="I";a["В"]="V";a["А"]="A";a["П"]="P";a["Р"]="R";a["О"]="O";a["Л"]="L";a["Д"]="D";a["Ж"]="ZH";a["Э"]="E";
        a["ф"]="f";a["ы"]="i";a["в"]="v";a["а"]="a";a["п"]="p";a["р"]="r";a["о"]="o";a["л"]="l";a["д"]="d";a["ж"]="zh";a["э"]="e";
        a["Я"]="Ya";a["Ч"]="CH";a["С"]="S";a["М"]="M";a["И"]="I";a["Т"]="T";a["Ь"]="";a["Б"]="B";a["Ю"]="YU";
        a["я"]="ya";a["ч"]="ch";a["с"]="s";a["м"]="m";a["и"]="i";a["т"]="t";a["ь"]="";a["б"]="b";a["ю"]="yu";
        a[" "]="";

        for (var i in word.toLowerCase()) {
            if (a[word[i]] === undefined) {
              answer += word[i];
            } else {
              answer += a[word[i]];
            }
        }

        answer = answer.substring(0,1).toUpperCase() + answer.substring(1);
        return answer;
      },

      isActive(menuItem) {
        return this.activeItem === menuItem;
      },
      setActive(menuItem) {
        this.activeItem = menuItem;
      },

      loadDependencies() {
        this.organizations = [];
        OrgAPI.search({pageNumber: 1, pageSize: -1, isOrgan: false})
          .then((response) => {
            var orglist = response.data.items.map(x => {return {id: x.id, text: x.name};});
            orglist.forEach((el) => {
                this.organizations.push(el);
            });
          // this.organizations.concat(response.data.items.map(x => {return {id: x.id, text: x.name};}));
          // console.log(this.organizations);
          this.organizations.sort(orgCompare);
        });
        OrgAPI.search({pageNumber: 1, pageSize: -1, isOrgan: true})
          .then((response) => {
            var orglist = response.data.items.map(x => {return {id: x.id, text: x.name ? x.name : x.nameFull};});
            //console.log(orglist);
            orglist.forEach((el) => {
                this.organizations.push(el);
            });
            //this.organizations.concat(orglist);
            //console.log(this.organizations);
          this.organizations.sort(orgCompare);
        });
      },
      loadRoles() {
        let orgIds = [];
        if (this.item.employees.length) {
          orgIds = this.item.employees.map(x => x.organizationId).join(',');
        }
        RoleAPI.search({pageNumber: 1, pageSize: -1, organizationIds: orgIds})
          .then((response) => {
            this.roles = response.data.items;
            //console.log(this.roles);
          });
      },
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.item = response.data;
            //console.log(this.item);
            this.loadRoles();
          });
        } else {
          this.loadRoles();
        }
      },
      save() {
        this.tab1Invalid = false;
        this.tab2Invalid = false;
        this.tab3Invalid = false;

        this.v$.$touch();        

        //перед сохранением надо проверить, что все 
        this.item.roleIds = this.item.roleIds.filter(roleId => {
          return this.roles.some(role => role.id == roleId);
        });

        if (this.v$.$invalid) {
          this.v$.$errors.forEach(e => {
            if (
              e.$response.extraParams &&
              e.$response.extraParams.scope === "tab1"
            ) {
              this.tab1Invalid = true;
            }          
          });
          if(this.v$.item.employees.$error) {
            this.tab2Invalid = true;
          }
          if(this.v$.item.roleIds.$error) {
            this.tab3Invalid = true;
          }

          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }        

        if (this.item.id) {
          API.update(this.item)
            .then(function () {
              Constants.alert.fire('Сохранение', 'Изменения сохранены.', 'success');
            })
            .catch(error => {
              if (error.response.status === 400 && error.response.data) {
                Constants.alert.fire('Сохранение', error.response.data, 'error');
              } else {
                Constants.alert.fire('Сохранение', 'Ошибка при сохранении изменений.', 'error');
              }
            });
        } else {
          API.create(this.item, window.location.origin)
            .then(() => {
              Constants.alert.fire('Сохранение', 'Информация о новом пользователе сохранена.', 'success')
              .then(() => {
                this.close();
              });
            })
            .catch(error => {
              if (error.response.status === 400 && error.response.data) {
                Constants.alert.fire('Сохранение', error.response.data, 'error');
              } else {
                Constants.alert.fire('Сохранение', 'Ошибка при создании пользователя.', 'error');
              }
            });
        }
      },
      close() {
        this.$router.push({name: 'Users', query: { page: this.$route.query.page }});
      },
      addOrganization() {
        const org = {organizationId: null, position: '', phone: '', additionalNumber: ''};
        this.item.employees.push(org);
      },
      organizationChanged() {
        this.loadRoles();
      },
      deleteOrganization(index) {
        this.item.employees.splice(index, 1);
        this.loadRoles();
      },
      isNew() {
        return !this.item.id;
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations () {
      return {
        item: {
          userName: {
            required,
            maxLength: maxLength(30)
          },
          email: {
            required,
            email,
            maxLength: maxLength(100)
          },
          surname: {
            required,
            maxLength: maxLength(255)
          },
          name: {
            required,
            maxLength: maxLength(255)
          },
          patronymic: {
            maxLength: maxLength(255)
          },
          phoneNumber: {
            maxLength: maxLength(20)
          },
          // password: {
          //   required: requiredIf(this.isNew),
          //   minLength: minLength(6),
          //   strength: (value) => {
          //     return !value || this.passRegExp.test(value);
          //   }
          // },
          // confirmPassword: {
          //   required: requiredIf(this.isNew),
          //   sameAsPassword: (value) => {
          //     return value === this.item.password;
          //   }
          // },
          employees: {
            required,
            function(value) {
              if (!value || !value.length) {
                return true;
              }
              let isValid = true;
              value.forEach(function(row) {
                if(!row.organizationId || !row.position)
                  isValid = false;
              });
              return isValid;
            }
          },
          roleIds: {
            required
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .nav-tabs {
      margin: 16px 36px 0 36px;
      justify-content: center;
      border: none;
      .nav-item {
        margin-top: 12px;
        max-width: 240px;
        min-width: 217px;
        width: 100%;
        margin-right: 8px;
        margin-left: 8px;
        .nav-link {
          padding: 14.5px 34.5px;
          text-align: center;
          font-family: "Source Sans Pro", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 120%;
          color: $gray-dark;
          border: 1px solid $gray-light1;
          box-sizing: border-box;
          border-radius: 6px;

          &.active {
            color: $blue-light;
            border: 1px solid $blue-light;
          }
        }
      }
    }
    .form-group.required .control-label:after {
        content:" *";
        color:red;
    }
    .form-check.required .control-label:after {
        content:" *";
        color:red;
    }
    .invalid-msg {
        color:red;
    }
    .card {
      padding: 24px;
      margin: 16px 24px 0 24px;
      border-radius: 12px;
      border: none;
      box-shadow: none;
      background-color: #fff;
    }

    .table-bordered td:first-child {
        width: 35%;
    }
</style>
<style lang="scss" scoped>
.select2::v-deep{
    .select2-container {
      max-width: 406px;
        width: 100% !important;
    }

    .select2-container--default .select2-selection--single {
        height: calc(2.25rem + 2px) !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__arrow {
        top: 7px !important;
    }
}
</style>